import React from "react";
import CardView from "./Card";

export interface Card {
	index: number;
	imageUrl: string;
	title: string;
	body: string;
	extendedBody?: string;
}

interface CardCotainerProp {
	cardList: Card[];
	selectedIndex?: Number;
	valueSelected(response?: any): void;
}

const CardCotainer: React.FC<CardCotainerProp> = ({ cardList, selectedIndex, valueSelected }): JSX.Element => {
	const [cardIndex, setCardIndex] = React.useState((typeof selectedIndex !== 'undefined')?(selectedIndex): -1);

	const valueClicked = (index: number) => {
		setCardIndex(index);
		valueSelected(index);
	};

	return (
		<div className="content">
			<div className="goal-content">
				{cardList.map((card, i) => {
					return (<CardView
						key={i}
						card={card}
						isSelected={cardIndex === i}
						valueSelected={(e) => {
							valueClicked(e);
						}}
					></CardView>);
				})}
			</div>
		</div>
	);
};

export default CardCotainer;
